import numbro from 'numbro'
import React, { useContext, useEffect, useState } from 'react'
import { Text, View } from 'react-native'
import { Divider } from 'react-native-paper'
import { ProjectDetailsContext } from './ProjectDetails'
import moment from 'moment'
import { ScrollView } from 'react-native-gesture-handler'
import { useTranslation } from 'react-i18next'

export const ProjectSummary = () => {
  const { t } = useTranslation('global')
  const { project, projectInvoices } = useContext(ProjectDetailsContext)

  const [totalInvoiceValue, setTotalInvoiceValue] = useState(0)

  const [projectAddress, setProjectAddress] = useState()
  const [projectType, setProjectType] = useState()

  useEffect(() => {
    if (projectInvoices) {
      setTotalInvoiceValue(
        projectInvoices.reduce((acc, item) => acc + item.total_amount, 0),
      )
    }
  }, [projectInvoices])

  useEffect(() => {
    if (project) {
      console.log('project', project)
      const { content: address } = project.document.data.projectInfo.items.find(
        (item) => item.identifier === 'projectAddress',
      )
      let optionalAddress2 = ''
      if (address.unitNumber) optionalAddress2 = address.unitNumber + ', '
      setProjectAddress(
        `${address.address}, ${optionalAddress2}${address.city}, ${address.state} ${address.zip}`,
      )

      const { content: type } = project.document.data.projectInfo.items.find(
        (item) => item.identifier === 'projectType',
      )
      setProjectType(type)
    }
  }, [project])

  return (
    <ScrollView style={{ backgroundColor: 'white' }}>
      <Text
        style={{
          marginBottom: 4,
          fontSize: 18,
          fontWeight: '600',
          lineHeight: 28,
        }}
      >
        $
        {numbro(totalInvoiceValue).format({
          thousandSeparated: true,
          mantissa: 2,
        })}
      </Text>
      <Text style={{ color: '#668598', fontWeight: '500', lineHeight: 21 }}>
        {t('Projects.total_invoice_value')}
      </Text>
      <Divider style={{ marginTop: 16, marginBottom: 14 }} />
      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <Text style={{ color: '#668598', fontWeight: '500' }}>
          {t('Projects.date_created')}
        </Text>
        <Text style={{ color: '#335C75', fontWeight: '500' }}>
          {moment(project?.createdAt).format('MMM D, YYYY')}
        </Text>
      </View>
      <Divider style={{ marginTop: 14, marginBottom: 14 }} />
      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <Text style={{ color: '#668598', fontWeight: '500' }}>
          {t('Projects.type')}
        </Text>
        <Text style={{ color: '#335C75', fontWeight: '500' }}>
          {projectType}
        </Text>
      </View>
      <Divider style={{ marginTop: 14, marginBottom: 14 }} />
      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <Text style={{ color: '#668598', fontWeight: '500', marginRight: 10 }}>
          {t('Projects.address')}
        </Text>
        <Text style={{ color: '#335C75', fontWeight: '500' }}>
          {projectAddress}
        </Text>
      </View>
    </ScrollView>
  )
}
